import type { RouteRecordRaw } from 'vue-router'

import { ensureRootRoutePath, type RedirectRoutePath } from '@/utilities/routers'

const routeAcceptSubscriptionName = '/accept-subscription'
const routeAcceptSubscriptionPath = ensureRootRoutePath(routeAcceptSubscriptionName)
const routeAcceptOpenDemoName = '/accept-open-demo'
const routeAcceptOpenDemoPath = ensureRootRoutePath(routeAcceptOpenDemoName)

const routeAcceptSubscription: RouteRecordRaw = {
  component: async () => {
    return await import('@/components/views/AcceptSubscriptionView.vue')
  },
  meta: {
    requireAuth: false,
  },
  name: routeAcceptSubscriptionName,
  path: routeAcceptSubscriptionPath,
}

const routeAcceptOpenDemo: RouteRecordRaw = {
  component: async () => {
    return await import('@/components/views/AcceptSubscriptionView.vue')
  },
  meta: {
    requireAuth: false,
  },
  name: routeAcceptOpenDemoName,
  path: routeAcceptOpenDemoPath,
}

const redirectAcceptSubscription: RedirectRoutePath = {
  // use no "name" attribute here, not working with global navigationGuard
  path: routeAcceptSubscription.path,
}

export {
  redirectAcceptSubscription,
  routeAcceptOpenDemo,
  routeAcceptOpenDemoName,
  routeAcceptSubscription,
}
